import axios from "axios";

import * as hp from "../../helpers"

require('formdata-polyfill')

const url = "http://obfportal.lo/api"

// hp.objectEntriesPolyfill();
// console.log('objEntriesP',hp.objectEntriesPolyfill)



    // if (!Object.values) {
    //     Object.values = function values(O) {
    //         return reduce(keys(O), (v, k) => concat(v, typeof k === 'string' && isEnumerable(O, k) ? [O[k]] : []), []);
    //     };
    // }


//End of polyfill


export const updateStep = ({commit,state, rootState}) => {
    axios.patch(rootState.baseurl + "fournisseurs",state.supplier,{
        headers:{
            "Content-Type":"application/json"
        }
    }).then(resp=>{

    }).catch(error=>{
        console.log('supplierError')
    })

}

export const uploadDoc = ({commit, state, rootState},data) => {

    // hp.objectEntriesPolyfill();

    // const reduce = Function.bind.call(Function.call, Array.prototype.reduce);
    // const isEnumerable = Function.bind.call(Function.call, Object.prototype.propertyIsEnumerable);
    // const concat = Function.bind.call(Function.call, Array.prototype.concat);
    // const keys = Reflect.ownKeys;


    // if (!Object.entries) {
    //     Object.entries = function entries(O) {
    //         return reduce(keys(O), (e, k) => concat(e, typeof k === 'string' && isEnumerable(O, k) ? [[k, O[k]]] : []), []);
    //     };
    // }


    console.log('FormData',FormData)

    let form = document.createElement('form')
    console.log(state)
    console.log('from uploadDoc Action', data)
    let fdata = new FormData(form)
    console.log('TypeOfFdata', fdata)
    fdata.append('file',data.file)
    fdata.append('fournisseur_id',data.data.fournisseur_id)
    fdata.append('param_document_id',data.data.param_document_id)
    console.log('fdata',fdata.entries())
    for(let key of fdata.entries()) console.log(key)

    axios.post(rootState.baseurl+"/documents",fdata,{
        headers:{
            "Content-Type":"application/json",
            "Authorization":"Bearer "+rootState.auth.token
        }
    }).then(docResp=>{
        console.log('fromDocContr',docResp)
    }).catch(error=>{
        console.log('error from DocContr', error)
    })
}

export const uploadOtherDoc = ({commit, state, rootState,dispatch},data) => {

    // hp.objectEntriesPolyfill();
 
    console.log(state)
    
    let form = document.createElement('form')
    console.log('from uploadDoc Action', data)
    let fdata = new FormData(form)
    fdata.append('file',data.file)
    fdata.append('fournisseur_id',data.data.fournisseur_id)
    fdata.append('libelle',data.data.libelle)
    fdata.append('description',data.data.description)
    console.log('fdata',fdata.entries())
    for(let key of fdata.entries()) console.log(key)

    axios.post(rootState.baseurl+"/autredocuments",fdata,{
        headers:{
            "Content-Type":"application/json",
            "Authorization":"Bearer "+rootState.auth.token
        }
    }).then(docResp=>{
        console.log('fromDocOtherContr',docResp)
        rootState.otherfiles = []
        dispatch('getOtherFiles')
    }).catch(error=>{
        console.log('error from OtherDocContr', error)
    })
}